import { useEffect, useState } from "react";

// Lightweight cookie/analytics consent banner (§40). Stores choice in localStorage.
// Analytics events are suppressed only when the user explicitly declines (see @/lib/site track()).
export const ConsentBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("avb_consent")) setShow(true);
  }, []);
  useEffect(() => {
    document.body.style.paddingBottom = show ? "150px" : "";
    return () => { document.body.style.paddingBottom = ""; };
  }, [show]);
  const choose = (v) => { localStorage.setItem("avb_consent", v); setShow(false); };
  if (!show) return null;
  return (
    <div data-testid="consent-banner" className="fixed inset-x-0 bottom-0 z-[60] mx-auto max-w-3xl px-4 pb-safe-4">
      <div className="rounded-2xl border border-stone-200 bg-white/95 p-4 shadow-lg backdrop-blur">
        <p className="text-sm text-stone-600">
          We use essential cookies to run Avinya Bookings and optional analytics to improve your experience.
          You can decline analytics anytime. See our <a href="/help" className="font-medium text-primary underline">privacy notice</a>.
        </p>
        <div className="mt-3 flex gap-2">
          <button data-testid="consent-accept" onClick={() => choose("accepted")} className="rounded-full bg-primary px-5 py-2 text-sm font-semibold text-white hover:bg-green-900">Accept</button>
          <button data-testid="consent-decline" onClick={() => choose("declined")} className="rounded-full border border-stone-300 px-5 py-2 text-sm font-medium text-stone-700 hover:bg-stone-50">Decline analytics</button>
        </div>
      </div>
    </div>
  );
};
